export const environment = {
  instance: "qa",
  production: false, 
  showLogs: true,
  region: 'ap-southeast-1', 
  bucketName: 'storage-bucket-name',
  cognitoUserPoolId: 'ap-southeast-1_fJ29AEsJa', 
  cognitoAppClientId: '1uc90p5bqmn24o525q975duvfd', 
  cognitoIdentityEndpoint: 'cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_fJ29AEsJa', 
  cognitoIdentityPoolId: 'ap-southeast-1:a6e158ec-9085-4376-8eb2-6aa1bffb7fe0',
  apiEndpoint: 'https://md1kre2gvi.execute-api.ap-southeast-1.amazonaws.com/qa/',  
  publicEndpoint: 'https://bocpwcsdevserver.eschost2.com/',
  showFaqFirst: true,
  allowLogin: true,
  consolidatorFaqUrl: "https://imsbbbconsolqa.eschost2.com/frequently-asked-questions",
  deconsolidatorFaqUrl: "https://imsbbbdeconsolqa.eschost2.com/frequently-asked-questions",
  ofwFaqUrl: "https://imsbbbqa.eschost2.com/frequently-asked-questions",
  auth: {
    identityPoolId: 'ap-southeast-1:a6e158ec-9085-4376-8eb2-6aa1bffb7fe0',
    region: 'ap-southeast-1',
    userPoolId: 'ap-southeast-1_fJ29AEsJa',
    userPoolWebClientId: '1uc90p5bqmn24o525q975duvfd',
    mandatorySignIn: false,
    authenticationFlowType: 'USER_SRP_AUTH'
  },
  api: {
    endpoints: [
      {
        name: "ConsolidatorAPIs",
        endpoint: "https://md1kre2gvi.execute-api.ap-southeast-1.amazonaws.com"
      }
    ]
  }
};